import React from "react";
import classnames from "classnames";
import { usePagination, DOTS } from "./usePagination";
// import "./pagination.scss";
import leftAngleIcon from "../../assets/images/leftAngleIcon.svg";
const Pagination = (props) => {
  const {
    onPageChange,
    totalCount,
    siblingCount = 1,
    currentPage,
    pageSize,
    className,
  } = props;

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  });

  if (currentPage === 0 || paginationRange.length < 2) {
    return null;
  }
  const onNext = () => {
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    onPageChange(currentPage - 1);
  };

  let lastPage = paginationRange[paginationRange.length - 1];
  return (
    <div className="paginationWrapper">
      <ul className={classnames("pagination", { [className]: className })}>
        <li
          className={classnames("pagination-item", {
            disabled: currentPage === 1,
          })}
          onClick={onPrevious}
        >
          <a className="leftArrow">
            {" "}
            <img src={leftAngleIcon} alt="" />
            Prev{" "}
          </a>
        </li>
        {paginationRange.map((pageNumber) => {
          if (pageNumber === DOTS) {
            return <li className="pagination-item dots">&#8230;</li>;
          }

          return (
            <div
              key={pageNumber}
              className={classnames("pagination-item", {
                selected: pageNumber === currentPage,
              })}
              onClick={() => onPageChange(pageNumber)}
            >
              <li>
                <a
                
                  className={currentPage === pageNumber ? "active" : ""}
                >
                  {" "}
                  {pageNumber}{" "}
                </a>
              </li>
            </div>
          );
        })}
        <li
          className={classnames("pagination-item", {
            disabled: currentPage === lastPage,
          })}
          onClick={onNext}
        >
          <a  className="rightArrow">
            {" "}
            Next
            <img src={leftAngleIcon} alt="" />{" "}
          </a>
        </li>
      </ul>
    </div>
  );
};

export default Pagination;
